import React from "react";

export const removeHtmlTags = (html) => {
  if (!html) {
    return ""; // Return an empty string if html is undefined or null
  }

  // Regular expression to match HTML tags with attributes
  const regex = /<([^>]+)>/g;

  // Remove HTML tags while retaining attributes and content
  return html.replace(regex, (match, p1) => {
    // Preserve any inline styles or other attributes
    if (p1.includes("style=")) {
      return match; // Return the tag with inline styles
    } else {
      return ""; // Remove the tag if it doesn't contain inline styles
    }
  });
};

function TruncateDescription({ description }) {
  // Function to truncate description to first 30 words
  const truncate = (text, limit) => {
    const words = text.split(" ");
    if (words.length > limit) {
      return words.slice(0, limit).join(" ") + "...";
    }
    return text;
  };

  return <>{truncate(description, 15)}</>;
}

export function formatDate(dateString) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = new Date(dateString);
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month} ${day}, ${year}`;
}

// export const removeHtmlTags = (html) => {
//     if (!html) {
//       return ''; // Return an empty string if html is undefined or null
//     }
//     const regex = /(<([^>]+)>)/ig;
//     return html.replace(regex, '');
//   };

// Utility function to fetch data from API and generate JSON file for download
// export async function fetchDataAndWriteToFile(url, filename) {
//     try {
//       const response = await fetch(url);
//       if (!response.ok) {
//         throw new Error('Failed to fetch data from the API');
//       }
//       const data = await response.json();
//       const jsonData = JSON.stringify(data, null, 2);
//       const blob = new Blob([jsonData], { type: 'application/json' });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', filename);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//       console.log('Data written to menu.json successfully');
//     } catch (error) {
//       console.error('Error fetching and writing data:', error);
//     }
// }

export { TruncateDescription };
